var exports = {
  "q": "BaseSettingsPage__nXUHBl",
};

module.exports = exports;
